const API_URL = process.env.REACT_APP_API_URL;

export default function Api() {
  const reservar = async function (
    name,
    email,
    document,
    phone,
    zipcode,
    address,
    number,
    complement,
    neighborhood,
    city,
    state,
    adults,
    children,
    animals,
    startDate,
    endDate,
    intention,
    casa,
    lances,
    experiencias,
    comida,
    restrictions
  ) {
    let _casas = [];
    if (casa) {
      _casas = [`${casa.id}`];
    }

    let _data = {
      name: name,
      email: email,
      document: document,
      phone: phone,
      zipcode: zipcode,
      address: address,
      number: number,
      complement: complement,
      neighborhood: neighborhood,
      city: city,
      state: state,
      adults: adults,
      children: children,
      animals: animals,
      special_care: false,
      start_date: startDate.toISOString(),
      end_date: endDate.toISOString(),
      intention: intention,
      casas: _casas,
      lances: lances,
      experiencias: experiencias,
      comida: comida ? comida.id : null,
      restrictions: restrictions,
    };
    console.log(_data);

    return fetch(API_URL + "/register/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(_data),
    }).then((data) => {
      return data.json();
    });
  };

  const reservarPacote = async function (
    name,
    email,
    document,
    phone,
    zipcode,
    address,
    number,
    complement,
    neighborhood,
    city,
    state,
    adults,
    children,
    animals,
    casa,
    pacote,
    total
  ) {
    let _casas = [];
    if (casa) {
      _casas = [`${casa.id}`];
    }

    let _data = {
      name: name,
      email: email,
      document: document,
      phone: phone,
      zipcode: zipcode,
      address: address,
      number: number,
      complement: complement,
      neighborhood: neighborhood,
      city: city,
      state: state,
      adults: adults,
      children: children,
      animals: animals,
      casas: _casas,
      pacote: pacote.id,
      total: total,
    };
    console.log(_data);

    return fetch(API_URL + "/pacotes/", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(_data),
    }).then((data) => {
      return data.json();
    });
  };

  const getCasas = async function (dateRange, people) {
    return fetch(API_URL + "/availability/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        start: dateRange[0].startDate.toISOString(),
        end: dateRange[0].endDate.toISOString(),
        people: people,
      }),
    }).then((data) => {
      return data.json();
    });
  };

  const getCasasPacotes = async function (id, people) {
    return fetch(API_URL + "/pacotes/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        people: people,
        id: id,
      }),
    }).then((data) => {
      return data.json();
    });
  };

  const getCasasPacotesAvailable = async function (pacote, people) {
    return fetch(API_URL + "/availability/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        start: pacote.start,
        end: pacote.end,
        people: people,
      }),
    }).then((data) => {
      return data.json();
    });
  };

  const getData = async function () {
    return fetch(API_URL + "/data/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((data) => {
      return data.json();
    });
  };

  const getPacotes = async function (date) {
    return fetch(API_URL + `/pacotes/?date=${date}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((data) => {
      return data.json();
    });
  };

  const getPacote = async function (id, adults, children) {
    return fetch(API_URL + `/pacote/${id}/${adults}/${children}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((data) => {
      return data.json();
    });
  };

  const getZipcode = async function (zipcode) {
    zipcode = zipcode.replace(".", "");
    zipcode = zipcode.replace("-", "");
    return new Promise((resolve, reject) => {
      return fetch(`https://viacep.com.br/ws/${zipcode}/json/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((data) => {
        resolve(data.json());
      });
    });
  };

  return {
    reservar,
    reservarPacote,
    getCasas,
    getCasasPacotes,
    getData,
    getPacotes,
    getPacote,
    getZipcode,
    getCasasPacotesAvailable,
  };
}
